import { render } from "./Skills.vue?vue&type=template&id=33bd234e&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=33bd234e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33bd234e"

export default script